export default __webpack_public_path__ + "static/media/upload_img.a6800b82.svg";